// extracted by mini-css-extract-plugin
export var container = "_df-0";
export var popoverContent = "_df-1";
export var tosLink = "_df-2";